import { render } from "./App.vue?vue&type=template&id=3820287c&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3820287c&lang=css"

import exportComponent from "/Users/jaakkojakara/Documents/Aekosbot/apps/aekosweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__